/* Gedeelde constanten voor de Sales Pipeline (stages, bron-kleuren). */
import React from "react";
import i18n from "i18next";
import { Linkedin, Mail, MessageCircle, Sparkles, Target, User as UserIcon } from "lucide-react";

export const STAGES = [
    { id: "new",       get label() { return i18n.t("pipeline_sales.stage_new"); },      color: "var(--jr-text-2)" },
    { id: "contacted", get label() { return i18n.t("pipeline_sales.stage_contacted"); },   color: "var(--jr-info)" },
    { id: "engaged",   get label() { return i18n.t("pipeline_sales.stage_engaged"); }, color: "var(--jr-amber)" },
    { id: "meeting",   get label() { return i18n.t("pipeline_sales.stage_meeting"); },    color: "var(--jr-brand)" },
    { id: "won",       get label() { return i18n.t("pipeline_sales.stage_won"); },        color: "var(--jr-success)" },
    { id: "lost",      get label() { return i18n.t("pipeline_sales.stage_lost"); },       color: "var(--jr-error)" },
];

// Color-coding per source — used both for the card border and the source-badge.
// Note: `manual` is now treated as "by me" (groen) per the user spec.
export const SOURCE_STYLE = {
    manual: {
        label: "MANUAL",
        badgeBg: "bg-[var(--jr-success)]/20",
        badgeText: "text-[var(--jr-success)]",
        badgeBorder: "border-[var(--jr-success)]/45",
        cardBorder: "border-[var(--jr-success)]/55 bg-[var(--jr-success)]/[0.04] hover:bg-[var(--jr-success)]/[0.08]",
        leftAccent: "before:bg-[var(--jr-success)]",
        Icon: UserIcon,
    },
    agent: {
        label: "AI AGENT",
        badgeBg: "bg-[var(--jr-info)]/20",
        badgeText: "text-[var(--jr-info)]",
        badgeBorder: "border-[var(--jr-info)]/45",
        cardBorder: "border-[var(--jr-info)]/45 bg-[var(--jr-info)]/[0.03] hover:bg-[var(--jr-info)]/[0.07]",
        leftAccent: "before:bg-[var(--jr-info)]",
        Icon: Sparkles,
    },
    pipeline_request: {
        label: "REQUEST",
        badgeBg: "bg-purple-500/20",
        badgeText: "text-purple-400",
        badgeBorder: "border-purple-500/45",
        cardBorder: "border-purple-500/45 bg-purple-500/[0.04] hover:bg-purple-500/[0.08]",
        leftAccent: "before:bg-purple-500",
        Icon: Target,
    },
};

export const CHANNEL_ICONS = { linkedin: Linkedin, email: Mail, whatsapp: MessageCircle };

export const sourceOf = (l) => l.source || (l.is_manual ? "manual" : "agent");

// Compacte euro-notatie voor dealwaardes: €950 · €4,5k · €25k · €1,2M
export const fmtEur = (v) => {
    const n = Number(v) || 0;
    if (n <= 0) return null;
    if (n >= 1000000) return `€${(n / 1000000).toFixed(1).replace(".", ",").replace(",0", "")}M`;
    if (n >= 10000) return `€${Math.round(n / 1000)}k`;
    if (n >= 1000) return `€${(n / 1000).toFixed(1).replace(".", ",").replace(",0", "")}k`;
    return `€${Math.round(n)}`;
};
